import { useEffect } from "react";
import SingleLandingPage from "../../../../components/Paid Traffic/Methodology/LPExperience/BestBettingSites/SingleLandingPage";
import { useSelector } from "react-redux";

import { useFetchKeywordDetails } from "../../hooks/useFetchKeywordDetails";
import DailyLandingPageExperienceSkeleton from "./DailyLandingPageExperienceSkeleton";
import { CheckPermissions } from "../../../../logic/Admin/Permissions/CheckPermission/CheckPermissions";
import { selectUserData } from "../../../../features/userSlice";
import Page404 from "../../../../components/Page404/Page403";

const BestBettingSitesScreen = () => {
  const response = useSelector(selectUserData);
  const hasViewSingleLandingPageExperienceTypesPermission = CheckPermissions(
    response?.data?.products?.paid_traffic,
    "plan_campaign_ppc",
    "view_keyword_lp_analysis"
  );
  const {
    fetchKeywordDetails,
    fetchSingleKeywordDetails,
    fetchDailyLPExperienceDetails,
    fetchCompetitorMetricsAccordion,
  } = useFetchKeywordDetails();
  const { lpLoader } = useSelector((state: any) => state.landingPageExperience);

  useEffect(() => {
    if (hasViewSingleLandingPageExperienceTypesPermission) {
      fetchKeywordDetails();
      fetchSingleKeywordDetails();
      fetchDailyLPExperienceDetails();
      fetchCompetitorMetricsAccordion();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {hasViewSingleLandingPageExperienceTypesPermission ? (
        lpLoader ? (
          <DailyLandingPageExperienceSkeleton />
        ) : (
          <SingleLandingPage />
        )
      ) : (
        <Page404 />
      )}
    </>
  );
};

export default BestBettingSitesScreen;
